import { c as _c } from "react/compiler-runtime";
import { PRIVACY_POLICY_URL } from "@/lib/legal-urls";

/**
 * Footer copy for login/signup. Privacy Policy is published on
 * sigmaidentity.com. Do not mention unpublished legal documents here.
 */
export function AuthLegalNotice() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p>By continuing, you agree to our{" "}<a className="underline underline-offset-4 hover:text-foreground" href={PRIVACY_POLICY_URL} rel="noopener noreferrer" target="_blank">Privacy Policy</a></p>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}